<template>
  <div class="switch">
    <ul class="buttons">
      <li
        v-if="existFreepass"
        v-bind:class="{
          active: isSelect === optionFreepass,
          button1: !existPremium && existFreepass,
          button2: existPremium && existFreepass
        }"
        @click="changeList(optionFreepass)"
      >
        <div class="inner"><p class="tab">フリーパス</p></div>
      </li>
      <li
        v-bind:class="{
          active: isSelect === optionCoupon,
          border: existPremium,
          button1:
            (existPremium && !existFreepass) ||
            (!existPremium && existFreepass),
          button2: existPremium && existFreepass
        }"
        @click="changeList(optionCoupon)"
      >
        <div class="inner"><p class="tab">クーポン</p></div>
      </li>
      <li
        v-if="existPremium"
        v-bind:class="{
          button1: existPremium && !existFreepass,
          button2: existPremium && existFreepass
        }"
        @click="tapPremium()"
        class="premium"
      >
        <div class="inner">
          <img src="~@/assets/img/coupon/icon_premium.svg" />
        </div>
        <div class="inner"><p class="tab">プレミアム</p></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  props: {
    select: { type: String },
    freepass: { type: Boolean },
    premium: { type: Boolean }
  },
  data: function() {
    return {
      optionFreepass: 'フリーパス',
      optionCoupon: 'クーポン',
      optionPremium: 'プレミアム',
      isSelect: 'クーポン',
      existFreepass: false,
      existPremium: false
    }
  },
  async created() {
    this.existFreepass = this.freepass
    this.existPremium = this.premium
    this.isSelect = this.select
  },
  methods: {
    changeList: function(isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    },
    tapPremium: function() {
      this.$emit('click', this.optionPremium)
    }
  }
}
</script>

<style scoped lang="scss">
.border {
  border-left: 1px solid #592711;
  border-right: 1px solid #592711;
}
.switch {
  display: block;
  text-align: center;
  padding: 15px 0;

  .buttons {
    width: 260px;
    margin: 0 auto;
    overflow: hidden;
    border: 1px solid #592711;
    border-radius: 5px;
    font-size: 12px;
    font-weight: bold;
    background-color: white;
    color: #592711;

    .button1 {
      display: inline-block;
      width: 50%;
      text-align: center;
      padding: 6px 0;
    }
    .button2 {
      display: inline-block;
      height: 100%;
      width: 33.3%;
      text-align: center;
      padding: 6px 0;
    }
    .active {
      background-color: #592711;
      color: white;
    }
    .tab {
      display: inline-block;
      margin-left: 1px;
      margin-top: 4.7px;
      padding-bottom: 5.3px;
    }
    .inner {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
